import { CountryCode } from ':constants/index';

export const CalendarEventCountry = {
    ALL: 'ALL',
    UNITED_ARAB_EMIRATES: CountryCode.UNITED_ARAB_EMIRATES,
    BELGIUM: CountryCode.BELGIUM,
    CANADA: CountryCode.CANADA,
    SWITZERLAND: CountryCode.SWITZERLAND,
    FRANCE: CountryCode.FRANCE,
    UNITED_KINGDOM: CountryCode.UNITED_KINGDOM,
    LUXEMBOURG: CountryCode.LUXEMBOURG,
    MOROCCO: CountryCode.MOROCCO,
    UNITED_STATES: CountryCode.UNITED_STATES,
    NETHERLANDS: CountryCode.NETHERLANDS,
    SPAIN: CountryCode.SPAIN,
    GERMANY: CountryCode.GERMANY,
    ITALY: CountryCode.ITALY,
} as const;

export type CalendarEventCountryType = (typeof CalendarEventCountry)[keyof typeof CalendarEventCountry];
